module.exports = __webpack_public_path__ + "static/taj-6bbaddfa22a2475c7c73b2f63e44fca1.png";